import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AssignScheduler, batches, SchedulerData } from '../model/schedulers-data';
import { SchedulerTarget } from '../model/schedulers-target';
import { SchedulerPageRequest } from '../model/scheduler-page-request';

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.spApiUrl;
  }

  public getSchedulers(request: SchedulerPageRequest): Observable<any> {
    console.log("Get all schedulers list..");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<SchedulerData>(this.baseUrl.concat("/schedulers").concat("/list"), request, {headers: headers});
  }

  public assignSchedulers(scheduler: AssignScheduler) {
    console.log("assigning new scheduler.."+scheduler.schedulerId);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(this.baseUrl.concat("/schedulers/assign")
      , scheduler, { headers: headers });
  }

  public assignSchedulersTarget(schedulers: SchedulerTarget) {
    console.log("assigning schedulers target.."+schedulers.projectId);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(this.baseUrl.concat("/schedulers/assign/target")
      , schedulers, { headers: headers });
  }

  public getSchedulersByProjectId(projectId: string): Observable<any> {
    console.log("Get schedulers by projectId.."+projectId);
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<SchedulerData>(this.baseUrl.concat("/schedulers").concat("/project/"+projectId), {headers: headers});
  }

  public getBatchesbySelectedProjectId(projectId: string): Observable<any> {
    console.log("Get Batches by projectId.."+projectId+"/batches");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<batches>(this.baseUrl.concat("/projects/"+projectId+"/batches/"), {headers: headers});
  }
}
